module.exports = __webpack_public_path__ + "static/media/upp_flo_joi_dec.c081347b.png";